export default __webpack_public_path__ + "static/media/sam-and-karen-beach-sunset.feb76e88.jpeg";